import API, { AUTH_HEADER } from 'base/api';
import { omit } from 'lodash';

export const UPDATE_STUDENT = 'UPDATE_STUDENT';
export const UPDATE_STUDENT_BEGIN = 'UPDATE_STUDENT_BEGIN';
export const UPDATE_STUDENT_SUCCESS = 'UPDATE_STUDENT_SUCCESS';
export const UPDATE_STUDENT_ERROR = 'UPDATE_STUDENT_ERROR';

export const updateStudentBegin = () => ({
  type: UPDATE_STUDENT_BEGIN
});

export const updateStudentSuccess = ( data ) => ({
  type: UPDATE_STUDENT_SUCCESS,
  payload: { data }
});

export const updateStudentError = ( error ) => ({
  type: UPDATE_STUDENT_ERROR,
  payload: { error }
});

export function updateStudent (student){
  const id = student._id;
  const data = omit(student, ['_id', 'recivedMail', 'sendMails', 'recordDate']);

  return dispatch => {
    dispatch(updateStudentBegin());
    return fetch(API.UPDATE_STUDENT + id, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: new Headers(AUTH_HEADER)
    })
      .then(handleErrors)
      .then(res => res.json())
      .then(json => {
        dispatch(updateStudentSuccess(student));
        return json;
      })
      .catch(error => dispatch(updateStudentError(error.message)));
  };
}

function handleErrors(response) {
  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response;
}


// WEBPACK FOOTER //
// ./src/modules/Admin/redux/actions/updateStudent.js